import { LogTemplate } from '../components/logs/LogTemplateBuilder';

export interface ItemResponse {
  item_id: number;
  response: any;
  notes: string;
  cannot_complete: boolean;
  cannot_complete_reason: string;
  file_uploads?: File[];
}

interface LogFieldResponseApi {
  field: number;
  response_value?: string;
  file_url?: string | null;
  file_name?: string | null;
}

interface LogEntryApi {
  id: number;
  occurred_at: string;
  log_template_detail?: LogTemplate;
  responses?: LogFieldResponseApi[];
}

export function parseStoredResponse(value: string | undefined, itemType: string): any {
  if (!value) {
    return itemType === 'checkbox' ? false : '';
  }

  if (itemType === 'checkbox') {
    return value === 'true' || value === 'True';
  }

  if (itemType === 'number_input') {
    const parsed = Number(value);
    return Number.isNaN(parsed) ? value : parsed;
  }

  if (itemType === 'multi_select' || itemType === 'location') {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  return value;
}

export function buildInitialResponsesFromEntry(entry: LogEntryApi): Record<number, ItemResponse> {
  const fieldMetaById = new Map(
    (entry.log_template_detail?.fields || []).map((field) => [field.id, field]),
  );
  const initial: Record<number, ItemResponse> = {};

  for (const response of entry.responses || []) {
    const fieldMeta = fieldMetaById.get(response.field);
    const itemType = fieldMeta?.item_type || 'text_input';
    let parsedResponse = parseStoredResponse(response.response_value, itemType);

    if ((itemType === 'file_upload' || itemType === 'photo') && response.file_url) {
      parsedResponse = response.file_url;
    }

    initial[response.field] = {
      item_id: response.field,
      response: parsedResponse,
      notes: '',
      cannot_complete: false,
      cannot_complete_reason: '',
    };
  }

  return initial;
}

export function serializeResponsesForApi(
  responses: Record<number, ItemResponse>,
): Record<string, { response: any }> {
  const payload: Record<string, { response: any }> = {};
  Object.entries(responses).forEach(([fieldId, data]) => {
    payload[fieldId] = { response: data.response };
  });
  return payload;
}
